export class ListConductivityprofiles {
  Id: number;
  TrainId: number;
  TableshortcodeDatetime: string;
  Stage: string;
  PvId: string;
  PermCond: string;
  CreatedAt: string;
  UpdatedAt: string;
}

export class Conductivityprofiles {
  Id: number;
  FieldValue: any[] = [];
}

export class ConductivityprofileElementsViewModel {
  TrainId?: number;
  TableshortcodeDatetime?: string;
  Stage?: number;
  PvId?: string;
  PermCond?: number;
}

export class FieldValue {
  TrainId: number;
  TableshortcodeDatetime: string;
  Stage: number;
  field: string;
  value: string;
  CreatedAt: string;
  UpdatedAt: string;
}

export class ConductivityprofileImport{
  TrainId:string;
  ImportOption:string=''; // future use
  SelWorksheet:number;
  HeaderRow:number;
  ColForStage:string;
  duplicateEleList:string='';
}


export class Fields {
  fieldA1: string = 'A1';
  valueA1: string;
  fieldA2: string = 'A2';
  valueA2: string;
  fieldA3: string = 'A3';
  valueA3: string;
  fieldA4: string = 'A4';
  valueA4: string;
  fieldA5: string = 'A5';
  valueA5: string;
  fieldB1: string = 'B1';
  valueB1: string;
  fieldB2: string = 'B2';
  valueB2: string;
  fieldB3: string = 'B3';
  valueB3: string;
  fieldB4: string = 'B4';
  valueB4: string;
  fieldB5: string = 'B5';
  valueB5: string;
  fieldC1: string = 'C1';
  valueC1: string;
  fieldC2: string = 'C2';
  valueC2: string;
  fieldC3: string = 'C3';
  valueC3: string;
  fieldC4: string = 'C4';
  valueC4: string;
  fieldC5: string = 'C5';
  valueC5: string;
  fieldD1: string = 'D1';
  valueD1: string;
  fieldD2: string = 'D2';
  valueD2: string;
  fieldD3: string = 'D3';
  valueD3: string;
  fieldD4: string = 'D4';
  valueD4: string;
  fieldD5: string = 'D5';
  valueD5: string;
  fieldE1: string = 'E1';
  valueE1: string;
  fieldE2: string = 'E2';
  valueE2: string;
  fieldE3: string = 'E3';
  valueE3: string;
  fieldE4: string = 'E4';
  valueE4: string;
  fieldE5: string = 'E5';
  valueE5: string;
  fieldF1: string = 'F1';
  valueF1: string;
  fieldF2: string = 'F2';
  valueF2: string;
  fieldF3: string = 'F3';
  valueF3: string;
  fieldF4: string = 'F4';
  valueF4: string;
  fieldF5: string = 'F5';
  valueF5: string;
  fieldG1: string = 'G1';
  valueG1: string;
  fieldG2: string = 'G2';
  valueG2: string;
  fieldG3: string = 'G3';
  valueG3: string;
  fieldG4: string = 'G4';
  valueG4: string;
  fieldG5: string = 'G5';
  valueG5: string;
}
export class DateWiseCpData {
  List1: ConductivityprofileElementsViewModel[];
  List2: ConductivityprofileElementsViewModel[];
  List3: ConductivityprofileElementsViewModel[];
 

}


